// bta-classic-page-init.js — OmyBoat
// Injecte le contexte produit Shopify sur les pages custom pour BTA.
(function () {
  var ctx = document.getElementById('bta-page-product-context');
  if (!ctx) return;
  var productId = parseInt(ctx.getAttribute('data-product-id'), 10);
  var variantId = parseInt(ctx.getAttribute('data-variant-id'), 10);
  if (!productId) return;

  // ShopifyAnalytics.meta.product — lu par le bootstrap BTA
  window.ShopifyAnalytics = window.ShopifyAnalytics || {};
  window.ShopifyAnalytics.meta = window.ShopifyAnalytics.meta || {};
  window.ShopifyAnalytics.meta.product = window.ShopifyAnalytics.meta.product || {
    id: productId,
    variants: [{ id: variantId }]
  };

  // Shopify.template — BTA vérifie si on est sur une page produit
  window.Shopify = window.Shopify || {};
  window.Shopify.template = window.Shopify.template || 'product';

  // meta.product — format alternatif utilisé par certaines versions du SDK
  window.meta = window.meta || {};
  window.meta.product = window.meta.product || { id: productId };
})();
